import React from 'react'
import { Layout } from 'antd'
import IntlMessages from 'util/IntlMessages'
// import { footerText } from 'util/config'

const Footer = () => {
	return (
		<Layout.Footer>
			<div className='gx-layout-footer-content'>
				<center>
					<p style={{ margin: 0 }}>
						<IntlMessages id='copyright' /> © {new Date().getFullYear()} <a
							href={'https://obhizatrik.org'}
							target='_blank'
							rel='noopener noreferrer'
						>
							<IntlMessages id='copyright.company' />
						</a> - <IntlMessages id='copyright.rights' /> <IntlMessages id='copyright.powered' /> <a
							href='https://quanticdynamics.com'
							target='_blank'
							rel='noopener noreferrer'
						>
							<IntlMessages id='copyright.developers' />
						</a>
					</p>
				</center>
				<center>
					<p style={{ paddingTop: '4px' }}>
						<a
							style={{ paddingRight: '4px' }}
							href={'https://obhizatrik.org/terms-conditions'}
							target='_blank'
							rel='noopener noreferrer'
						>
							<IntlMessages id='copyright.terms' />
						</a>
						<span> | </span>
						<a
							style={{ paddingLeft: '4px' }}
							href={'https://obhizatrik.org/privacy-policy'}
							target='_blank'
							rel='noopener noreferrer'
						>
							<IntlMessages id='copyright.privacy' />
						</a>
					</p>
				</center>
			</div>
		</Layout.Footer>
	)
}
export default Footer
